import { createSelector } from '@reduxjs/toolkit';
import { ProjectParameters } from 'ducks/types/store-types';
import { RootState } from 'store';

const scheduledBatchParametersSlice = (state: RootState) => state.scheduled_batch_parameters;

export const selectScheduledBatchParameters = createSelector(
  [scheduledBatchParametersSlice],
  (state): ProjectParameters => state,
);
